/* eslint-disable @typescript-eslint/camelcase */
import { BaseEvent } from './BaseEvent';
const eventList = {
    'application.install': 1,
    'application.upgrade': 2,
    'application.launch': 3,
    'application.exit': 4,
    'application.suspend': 5,
    'application.resume': 6,
};
export class ApplicationEvent extends BaseEvent {
    constructor(eventName) {
        super();
        this.application_account_numer = 0;
        this.application_install_date = 0;
        this.application_plugin = 'swm-snowplow-post';
        this.application_upgrade_date = 0;
        if (eventList[eventName] === undefined) {
            throw new Error(`${eventName} event is not supported by this library.`);
        }
        this.event_group = 'Application';
        this.event_id = eventList[eventName];
        this.event_name = eventName;
    }
}
//# sourceMappingURL=ApplicationEvent.js.map